import navPopularStores from './navPopularStores';

export default navPopularStores;
